<template>
	<div class="news_list">
		<!-- 公共头 start -->
		<Header></Header>
		<!-- 公共头 end -->

		<!-- 面包屑 start -->
		<div class="crumb container" v-if="categorys">
			当前位置：
			<a @click="toPage('/')" style="cursor: pointer;" target="_parent">首页</a>
			&nbsp;&gt;&nbsp;
			<a target="_parent">{{ menuInfo.name }}</a>
		</div>
		<div class="crumb container" v-if="keywords">
			当前位置：
			<a @click="toPage('/')" style="cursor: pointer;" target="_parent">首页</a>
			&nbsp;&gt;&nbsp;
			搜索
		</div>
		<!-- 面包屑 end -->

		<div class="container bg-white padd m-mt20">
			<ul class="lists">
				<li class="iframelist" style="cursor: pointer;" v-for="(item, index) in newsList" :key="index">
					<div>
						<a target="_blank" class="title" @click="toPage('/news_info?id=' + item.id)">{{ item.title }}</a>
						<p class="time">{{ item.publishTime }}</p>
					</div>
				</li>
			</ul>
			<div class="page_num" style="text-align: center;">
				<!-- <div id="page_div">
					<li class="home_page"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0.shtml&#39;)">首页</a></li>
					<li class="prev_page"><span>上一页</span></li>
					<li class="page_index"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0.shtml&#39;)" class="current">1</a></li>
					<li class="page_index"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0_2.shtml&#39;)">2</a></li>
					<li class="page_index"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0_3.shtml&#39;)">3</a></li>
					<li class="prev_page"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0_2.shtml&#39;)">下一页</a></li>
					<li class="end_page"><a href="javascript:void(0)" onclick="goPage(&#39;code_0&#39;,&#39;code_0_3.shtml&#39;)">尾页</a></li>
					<li class="page_jump">前往<input id="page_input" type="text" onkeypress="if (event.keyCode == 13){pageJump1(&#39;code_0&#39;,&#39;shtml&#39;,3)}" />页<a href="javascript:;" onclick="pageJump1(&#39;code_0&#39;,&#39;shtml&#39;,3)">确定</a></li>
				</div> -->
				<el-pagination background layout="prev, pager, next" :total="total" :current-page="pageNum" @current-change="getNewsList"></el-pagination>
			</div>
		</div>

		<!-- 公共尾 start -->
		<Footer></Footer>
		<!-- 公共尾 end -->
	</div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
	components: {
		Header,
		Footer
	},
	name: 'NewsList',
	data() {
		return {
			menuInfo: {},
			newsList: [],
			keywords: null,
			categorys: null,
			pageNum: 1,
			pageSize: 10,
			total: 0
		};
	},
	watch: {
		$route: function() {
			// console.log(this.$route.query.category);
			if (this.$route.query.category) {
				this.categorys = this.$route.query.category;
				this.keywords = null;
			}
			if (this.$route.query.keywords) {
				this.keywords = this.$route.query.keywords;
				this.categorys = null;
			}
			this.pageNum = 1;
			this.getNewsList(this.pageNum);
		}
	},
	mounted() {
		// console.log(this.$route.query);
		if (this.$route.query.category) {
			this.categorys = this.$route.query.category;
			this.keywords = null;
		}
		if (this.$route.query.keywords) {
			this.keywords = this.$route.query.keywords;
			this.categorys = null;
		}
		this.pageNum = 1;
		this.getNewsList(this.pageNum);
	},
	methods: {
		// 获取新闻列表
		getNewsList(val) {
			this.pageNum = val;
			this.req({
				url: '/system/news/list',
				params: {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					category: this.categorys,
					keywords: this.keywords
				},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.newsList = res.rows;
					this.total = res.total;
					if (this.categorys) {
						this.getMenuInfo(this.categorys);
					}
				}
			});
		},

		// 获取菜单详情
		getMenuInfo(ids) {
			this.req({
				url: '/system/menus/' + ids,
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					// this.menuList = res.rows;
					console.log(res);
					if (res.data.parentId == 0) {
						this.menuInfo = res.data;
					}
				}
			});
		},
		toPage(path) {
			this.$router.push(path);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/news_list/common.css"></style>
<style scoped src="../assets/news_list/lists.css"></style>
<style scoped src="../assets/news_list/xxcx.css"></style>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/news_list.vue